// Import Swiper React components
import {
  EffectFade,
  EffectCoverflow,
  Navigation,
  Pagination,
  Autoplay,
} from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/effect-fade";
import { useState } from "react";

//   SwiperCore.use([Autoplay]);

export default () => {
  const [currentSlide, setCurrentSlide] = useState(1);
  const [swiperInstance, setSwiperInstance] = useState(null);

  const Slides = [
    {
      name: "SERENA 1",
      image: "/assets/images/Serena-1.jpg",
    },
    {
      name: "ZC",
      image: "/assets/images/ZC.jpg",
    },
    {
      name: "Bahria",
      image: "/assets/images/Bahria.jpg",
    },
    {
      name: "DHA",
      image: "/assets/images/DH.jpg",
    },
    {
      name: "Etihad town",
      image: "/assets/images/etihad.jpg",
    },
    {
      name: "KT",
      image: "/assets/images/KT.jpg",
    },
    {
      name: "Lake City",
      image: "/assets/images/lake-city.jpg",
    },
    {
      name: "NLC",
      image: "/assets/images/NLC.jpg",
    },
  ];
  return (
    <div className="container mx-auto ">
      <Swiper
        // autoplay={true}
        autoplay={{ delay: 3000 }}
        delay={1000}
        effect="fade"
        grabCursor={true}
        // loop={true}
        pagination={{ el: "#custom-pagination", clickable: true }}
        breakpoints={{
          300: {
            slidesPerView: 1.3,
            spaceBetween: 1,
          },
          400: {
            slidesPerView: 1.5,
          },
          450: {
            slidesPerView: 1.7,
          },
          600: {
            slidesPerView: 2.2,
          },
          650: {
            slidesPerView: 2.5,
          },
          800: {
            slidesPerView: 3,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          1200: {
            slidesPerView: 5,
            spaceBetween: 20,
          },
        }}
        onSlideChange={(swiper) => {
          setCurrentSlide(swiper.realIndex + 1);
        }}
        onSwiper={(swiper) => {
          setSwiperInstance(swiper);
        }}
        modules={[EffectCoverflow, Pagination, Navigation]}
        className=" w-full max-w-[1480px] mx-auto "
      >
        {Slides.map((image, index) => {
          return (
            <SwiperSlide className=" flex flex-col justify-center items-center  px-4">
              <div className="relative h-[330px] w-[250px] overflow-hidden flex flex-col justify-center items-center">
                <img
                  src={image.image}
                  alt="slide_image"
                  className="rounded-xl w-[250px]  h-[300px] object-cover"
                />
                <div className="rounded-xl w-[250px]  h-[290px] object-cover absolute top-0 bg-black/10"></div>
                <div className="p-2 text-center">
                  <p>{image.name}</p>
                </div>
              </div>
            </SwiperSlide>
          );
        })}
        <div className="flex  justify-center items-center px-4 md:px-[40px] gap-[20px] lg:gap-[70px] xl:gap-[105px]  mx-aut0 p-4">
          <div className="flex gap-2">
            <div
              className="p-2 rounded-full cursor-pointer shadow-sm border hover:border-black/25 fill-currentColor "
              onClick={(swiper) => {
                setCurrentSlide(currentSlide - 2);
                swiperInstance.slideTo(currentSlide - 2);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                //   fill="currentColor"
                aria-hidden="true"
                className=" h-5 w-5 tranform rotate-90  "
              >
                <path
                  fill-rule="evenodd"
                  d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                  clip-rule="evenodd"
                ></path>
              </svg>
            </div>
            <div
              className="p-2 rounded-full cursor-pointer shadow-sm border hover:border-black/25 fill-currentColor "
              onClick={(swiper) => {
                setCurrentSlide(currentSlide + 1);
                swiperInstance.slideTo(currentSlide + 1);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                //   fill="currentColor"
                aria-hidden="true"
                className=" h-5 w-5 tranform -rotate-90  "
              >
                <path
                  fill-rule="evenodd"
                  d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                  clip-rule="evenodd"
                ></path>
              </svg>
            </div>
          </div>
        </div>
      </Swiper>
    </div>
  );
};

{
  /* <div className="slider-controler"> */
}
{
  /* <div className="swiper-button-prev slider-arrow">
              <ion-icon name="arrow-back-outline"></ion-icon>
            </div> */
}
{
  /* <div className="swiper-button-next slider-arrow">
              <ion-icon name="arrow-forward-outline"></ion-icon>
            </div> */
}
{
  /* <div className=" pagination-container swiper-number flex items-center text-[#808191] text-[14px]">
              <p className="swiper-pagination flex "></p>
              <p className="hidden lg:block">
                Showing {currentSlide}/{Slides.length}
              </p>
            </div> */
}
{
  /* </div> */
}
{
  /* custom pagination */
}

// <Swiper
// // effect={"coverflow"}

// // autoplay={true}
// // delay={1000}
// grabCursor={true}
// // centeredSlides={true}
// loop={true}
// // coverflowEffect={{
// //   rotate: 0,
// //   stretch: 0,
// //   depth: 100,
// //   modifier: 2.5,
// // }}
// pagination={{ el: "#custom-pagination", clickable: true }}
// breakpoints={{
//   // when window width is <= 640px
//   300: {
//     slidesPerView: 1,
//     spaceBetween: 10,
//   },
//   400: {
//     slidesPerView: 1,
//     spaceBetween: 10,
//   },
//   450: {
//     slidesPerView: 1.5,
//     spaceBetween: 15,
//   },
//   800: {
//     slidesPerView: 2,
//     spaceBetween: 20,
//   },
//   // when window width is <= 1024px
//   1024: {
//     slidesPerView: 2.5,
//     spaceBetween: 30,
//   },
// }}
// // navigation={{
// //   nextEl: ".swiper-button-next",
// //   prevEl: ".swiper-button-prev",
// //   clickable: true,
// // }}

// Import Swiper React components
// import {
//   EffectFade,
//   EffectCoverflow,
//   Navigation,
//   Pagination,
//   Autoplay,
// } from "swiper/modules";
// import { Swiper, SwiperSlide } from "swiper/react";
// // Import Swiper styles
// import "swiper/css";
// import "swiper/css/effect-coverflow";
// import "swiper/css/pagination";
// import "swiper/css/navigation";
// import "swiper/css/effect-fade";
// import { useState } from "react";

// //   SwiperCore.use([Autoplay]);

// export default () => {
//   const [currentSlide, setCurrentSlide] = useState(1);
//   const [swiperInstance, setSwiperInstance] = useState(null);

//   const Slides = [
//     {
//       image: "/assets/pictures/slide_1.svg",
//     },
//     {
//       image: "/assets/pictures/slide_2.svg",
//     },
//     {
//       image: "/assets/pictures/slide_3.svg",
//     },
//     {
//       image: "/assets/pictures/slide_1.svg",
//     },
//     {
//       image: "/assets/pictures/slide_2.svg",
//     },
//     {
//       image: "/assets/pictures/slide_3.svg",
//     },
//   ];
//   return (
//     <div className="container mx-auto ">
//       <Swiper
//         // autoplay={true}
//         autoplay={{ delay: 3000 }}
//         delay={1000}
//         effect="fade"
//         grabCursor = {true}
//         // loop={true}
//         pagination={{ el: "#custom-pagination", clickable: true }}
//         breakpoints={{
//           300: {
//             slidesPerView: 1,
//             spaceBetween: 10,
//           },
//           400: {
//             slidesPerView: 1,
//             spaceBetween: 10,
//           },
//           450: {
//             slidesPerView: 1.5,
//             spaceBetween: 15,
//           },
//           800: {
//             slidesPerView: 2,
//             spaceBetween: 20,
//           },
//           1024: {
//             slidesPerView: 2.5,
//             spaceBetween: 30,
//           },
//         }}
//         onSlideChange={(swiper) => {
//           setCurrentSlide(swiper.realIndex + 1);
//         }}
//         onSwiper={(swiper) => {
//           setSwiperInstance(swiper);
//         }}
//         modules={[EffectCoverflow, Pagination, Navigation]}
//         className=" w-full  "
//       >
//         {Slides.map((image, index) => {
//           return (
//             <SwiperSlide className="lg:mr-[30px]  w-[200px]  lg:w-[608px]   ">
//               <img
//                 src={image.image}
//                 alt="slide_image"
//                 className="rounded-3xl  lg:w-full "
//               />
//             </SwiperSlide>
//           );
//         })}

//         <div className="flex  justify-center items-center px-4 md:px-[40px] gap-[20px] lg:gap-[70px] xl:gap-[105px] pt-[38px] mx-aut0">
//           {/* <p className=" text-[#ffffff] whitespace-nowrap leading-5 text-[14px]">
//             Showing {currentSlide}/{Slides.length}
//           </p> */}
//           <div className="flex gap-2 lg:gap-4 xl:gap-[24px] px-[32px]">
//             {Slides.map((image, index) => {
//               return (
//                 <div
//                   className={` w-[10px] h-[10px] md:w-[12px] md:h-[12px] rounded-full
//                 hover:border-[#009932] hover:bg-transparent cursor-pointer ${
//                   currentSlide == index + 1
//                     ? " bg-[#009932] border-2  border-white "
//                     : "bg-[#009932] border-2 border-white/50"
//                 }`}
//                   onClick={(swiper) => {
//                     setCurrentSlide(index + 1);
//                     swiperInstance.slideTo(index);
//                   }}
//                 ></div>
//               );
//             })}
//           </div>
//         </div>
//       </Swiper>
//     </div>
//   );
// };

{
  /* <div className="slider-controler"> */
}
{
  /* <div className="swiper-button-prev slider-arrow">
              <ion-icon name="arrow-back-outline"></ion-icon>
            </div> */
}
{
  /* <div className="swiper-button-next slider-arrow">
              <ion-icon name="arrow-forward-outline"></ion-icon>
            </div> */
}
{
  /* <div className=" pagination-container swiper-number flex items-center text-[#808191] text-[14px]">
              <p className="swiper-pagination flex "></p>
              <p className="hidden lg:block">
                Showing {currentSlide}/{Slides.length}
              </p>
            </div> */
}
{
  /* </div> */
}
{
  /* custom pagination */
}

// <Swiper
// // effect={"coverflow"}

// // autoplay={true}
// // delay={1000}
// grabCursor={true}
// // centeredSlides={true}
// loop={true}
// // coverflowEffect={{
// //   rotate: 0,
// //   stretch: 0,
// //   depth: 100,
// //   modifier: 2.5,
// // }}
// pagination={{ el: "#custom-pagination", clickable: true }}
// breakpoints={{
//   // when window width is <= 640px
//   300: {
//     slidesPerView: 1,
//     spaceBetween: 10,
//   },
//   400: {
//     slidesPerView: 1,
//     spaceBetween: 10,
//   },
//   450: {
//     slidesPerView: 1.5,
//     spaceBetween: 15,
//   },
//   800: {
//     slidesPerView: 2,
//     spaceBetween: 20,
//   },
//   // when window width is <= 1024px
//   1024: {
//     slidesPerView: 2.5,
//     spaceBetween: 30,
//   },
// }}
// // navigation={{
// //   nextEl: ".swiper-button-next",
// //   prevEl: ".swiper-button-prev",
// //   clickable: true,
// // }}
